<div #fullscreen>
  <ng-container *ngIf="!!base64Src || !!url">
    @if (useIframe) {
      <iframe
        [src]="base64Src | safeHtml"
        style="min-height: 100vh"
        width="100%"
      ></iframe>
    } @else {
      @if (base64Src) {
        <ngx-extended-pdf-viewer
          src="data:application/pdf;base64,{{base64Src}}"
          [customToolbar]="customToolbar"
          [filenameForDownload]="filenameForDownload"
          [forceUsingLegacyES5]="true"
          [height]="height"
          [showUnverifiedSignatures]="true">
        </ngx-extended-pdf-viewer>
      }
      @if (url) {
        <ngx-extended-pdf-viewer
          [src]="url"
          [customToolbar]="customToolbar"
          [filenameForDownload]="filenameForDownload"
          [forceUsingLegacyES5]="true"
          [height]="height"
          [showUnverifiedSignatures]="true">
        </ngx-extended-pdf-viewer>
      }
    }

  </ng-container>
</div>

<ng-template #customToolbar>
  <div id="toolbarViewer">
    <div id="toolbarViewerLeft">
      <pdf-toggle-sidebar></pdf-toggle-sidebar>
      <div class="toolbarButtonSpacer"></div>
      <pdf-find-button [showFindButton]="showFindButton" [textLayer]="textLayer"></pdf-find-button>
      <pdf-paging-area></pdf-paging-area>
    </div>
    <div id="toolbarViewerRight">
      <pdf-select-tool></pdf-select-tool>
      <pdf-hand-tool *ngIf="showHandToolButton"></pdf-hand-tool>
      <pdf-rotate-page></pdf-rotate-page>

      <button (click)="toggleFullScreen()" *ngIf="showOpenFullscreenBtn" class="toolbarButton new-tab hiddenMediumView"
              matTooltip="Open Fullscreen" type="button">
        <mat-icon>fullscreen</mat-icon>
      </button>

      <button (click)="toggleFullScreen()" *ngIf="!showOpenFullscreenBtn" class="toolbarButton new-tab hiddenMediumView"
              matTooltip="Close Fullscreen" type="button">
        <mat-icon>fullscreen_exit</mat-icon>
      </button>

      <pdf-print></pdf-print>
      <pdf-download *ngIf="showDownloadButton"></pdf-download>
      <div class="verticalToolbarSeparator hiddenSmallView"></div>
      <pdf-toggle-secondary-toolbar></pdf-toggle-secondary-toolbar>
    </div>
    <pdf-zoom-toolbar></pdf-zoom-toolbar>
  </div>
</ng-template>
